// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import clsx from "clsx";
import { useVisualContext } from "../../components/visual-context";
import { useCurrentMode, useDensityMode, useVisualRefresh } from "../use-visual-mode";
export function usePortalModeClasses(ref) {
    var _a;
    var colorMode = useCurrentMode(ref);
    var densityMode = useDensityMode(ref);
    var context = useVisualContext(ref);
    var visualRefresh = useVisualRefresh();
    return clsx((_a = {
        "awsui-polaris-dark-mode awsui-dark-mode": colorMode === "dark",
        "awsui-polaris-compact-mode awsui-compact-mode": densityMode === "compact",
        "awsui-visual-refresh": visualRefresh
    }, _a["awsui-context-".concat(context)] = context, _a));
} //# sourceMappingURL=index.js.map
